import { handleApiError, NO_AUTH_API } from '../../utils/axios';

export const login = async (credentials) => {
  try {
    const response = await NO_AUTH_API.post('/api/v1/auth/authenticate', credentials);
    return { error: null, data: response.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const refresh = async () => {
  const response = await NO_AUTH_API.post('/api/v1/auth/refreshToken', {});
  return response.data;
};

export const logout = async () => {
  try {
    await NO_AUTH_API.post('/api/v1/auth/logout', {});
  } catch (_) {
    // Server-side revoke is best-effort. Client-side cleanup still happens.
  }
};
